import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    checkPermission,
    getDefaultOptionByValue,
    getGreekCurrencyFormat,
    isEmpty
} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import axios from "axios";
import {getICCategoryOptions, getICTypeOptions, getInvoiceTypesOptions} from "../../../../_helpers/sharedmydata";
import Loader from "../../../primer/POPUP-COMPONENTS/Loader/PrimerLoader";
import {toast} from "react-toastify";
import {Badge, Col, Modal, Row, Spinner} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import DateBox from "../../../primer/DateBox";
import Button from "react-bootstrap/Button";
import EditableTable from "../../../primer/Editable-Table";
import Input from "../../../common/Input";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import {
    setForceRefreshMyDataSalesReport, setSalesMyDataReportClientsData, setSalesMyDataReportData,
    setSalesMyDataReportRequestData,
    setSalesMyDataReportTotals
} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import NewSaleModal from "../../../primer/POPUP-COMPONENTS/NewSaleModal/NewSaleModal";
import {fetchAdvancedTypesSales, fetchSalesGeneralSettings} from "../../../../_apis/api";
import MassSaleModal from "../../../primer/POPUP-COMPONENTS/MassSaleModal";
import BetterCheckBox from "../../../common/BetterCheckBox";
import ReportsTemplate from "../../../common/ReportsTemplate";
import ClassificationsDifferencesTable from "../ClassificationsDifferencesTable";
import MassFetchClassificationsModal
    from "../../../primer/POPUP-COMPONENTS/MassClassifications/MassFetchClassificationsModal";
import MassSendClassificationsModal
    from "../../../primer/POPUP-COMPONENTS/MassClassifications/MassSendClassificationsModal";
import {openAccountingRecordLocal, openSaleLocal, openTabByType} from "../../../../_helpers/tabOpeners";
import {FaFileInvoice, FaInfoCircle} from "react-icons/fa";
import {MdDeselect} from "react-icons/md";
import SendToAiModal from "../../../primer/POPUP-COMPONENTS/SendToAiModal";
import {Popover} from "antd";
import {formatAIDocumentStatus} from "../AI/aiHelper";
import {
    initialAiModuleRequestData, initialAiMrModuleRequestData,
    setAIModuleRequestData,
    setAIModuleType,
    setAIMrModuleRequestData
} from "../../../../_reducers/aiSlice";
import {RiGeminiFill} from "react-icons/ri";
import {useTranslation} from "../../../../hooks/useTranslation";

const SalesMydataReport = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const SALES = useSelector((state) => state.SALES);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const requestData = useSelector((state) => state.SALES.salesMyDataReportRequestData);
    const totals = useSelector((state) => state.SALES.salesMyDataReportTotals);
    const salesReportData = useSelector((state) => state.SALES.salesMyDataReportData);
    const showClientsData = useSelector((state) => state.SALES.salesMyDataReportClientsData);
    const aiSettings = useSelector((state) => state.AI.aiSettings);
    const [incrKey, setIncrKey] = useState(0);

    const [loading, setLoading] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const invoiceTypes = getInvoiceTypesOptions("all");
    const icCategory = getICCategoryOptions();
    const icType = getICTypeOptions(true);
    const showFilterOptions = [{value: 'all', label: t('SalesMyData.table2.allDocuments')},{value: 'differences', label: t('SalesMyData.table2.onlyDifferences')}, {value: 'success', label: t('SalesMyData.table2.onlyTheSent')}, {value: 'failed', label: t('SalesMyData.table2.onlyTheFailed')}];
    const invoicesFromChannelOptions = [
        {value: 'all', label: "Προβολή όλων"},
        {value: 'provider', label: "Μόνο από παρόχους ηλεκτρονικής τιμολόγησης"},
        {value: 'myData', label: "Μόνο εκτός παρόχων ηλεκτροκινικής τιμολόγησης"},
    ];

    const [showClassificationsModal, setShowClassificationsModal] = useState(false);
    const [classificationsTableData, setClassificationsTableData] = useState([]);
    const [pageChanged, setPageChanged] = useState(false);
    const [sendClassificationLoading, setSendClassificationLoading] = useState(false);

    const [showNewSaleModal, setShowNewSaleModal] = useState(false);
    const [classificationsRowData, setClassificationsRowData] = useState({});

    const [showMassFetchModal, setShowMassFetchModal] = useState(false);
    const [showMassFetchClassModal, setShowMassFetchClassModal] = useState(false);
    const [showMassSendClassModal, setShowMassSendClassModal] = useState(false);
    const [showMassSendAiModal, setShowMassSendAiModal] = useState(false);

    const saleMarkFromCloud = useSelector((state) => state.CLOUD.saleMarkFromCloud);
    const [forceRefreshReport, setForceRefreshReport] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const canSeeAI = checkPermission("custom-ai", permissionsData) && aiSettings?.enableCloudAI === true;

    const isDemoCompany = companyDetails?.isDemoCompany === true;

    useEffect(() => {
        if (SALES.forceRefreshMyDataSalesReport === "force") {
            dispatch(setForceRefreshMyDataSalesReport(""));
            fetchReport(true, false);
        } else if (salesReportData?.length === 0 || SALES.forceRefreshMyDataSalesReport === "soft") {
            dispatch(setForceRefreshMyDataSalesReport(""));
            fetchReport(false, false);
        }
    }, []);

    useEffect(() => {
        if (isDemoCompany && moment(requestData.date_to, "DD/MM/YYYY").diff(moment(requestData.date_from, "DD/MM/YYYY"), "days") > 31) {
            dispatch(setSalesMyDataReportRequestData({...requestData, date_to: moment(requestData.date_from, "DD/MM/YYYY").add(30, "days").format("DD/MM/YYYY")}))
        }
    }, [requestData])

    useEffect(() => {
        if (forceRefreshReport) {
            fetchReport();
            setForceRefreshReport(false);
        }
    }, [forceRefreshReport]);

    const handleClassificationClicked = (rowData) => {
        if(rowData.hasOwnProperty('name')) {
            let cloneReqData = {...requestData};
            cloneReqData.showClients = false;
            if((rowData?.vat === "000000000" || rowData?.vat === "999999999" || rowData?.vat === company.vatNumber)) {
                cloneReqData.invoiceType = [invoiceTypes.find((inv) => inv.value === rowData.name)];
            } else {
                cloneReqData.clientVAT = rowData.vat;
            }
            dispatch(setSalesMyDataReportRequestData(cloneReqData));
            setForceRefreshReport(true);
            return;
        }

        if(rowData?.classifications.length > 0) {
            setClassificationsTableData(rowData.classifications);
        } else {
            setClassificationsTableData([]);
            toast.error("Δεν βρέθηκαν χαρακτηρισμοί.");
        }
        setClassificationsRowData(rowData);
        setShowClassificationsModal(true);
    }
    const sendClassifications = async (fromMass = false, res) => {
        if (res.classifications?.some((classification) => isEmpty(classification.classificationCategory))) {
            return toast.error("Παρακαλώ συμπληρώστε κατηγορία MyData σε όλες τις γραμμές.");
        }
        setSendClassificationLoading(true);
        let incomeClassificationsDetails = [];
        if (res.classifications?.length > 0){
            res.classifications.map(classification => {
                incomeClassificationsDetails.push({
                    "icls:lineNumber": classification.lineNumber,
                    "icls:incomeClassificationDetailData": {
                        "icls:classificationType": classification.classificationType,
                        "icls:classificationCategory" : classification.classificationCategory,
                        "icls:amount": classification.netPrice
                    },
                });
                return classification;
            })
        }
        let requestData = {
            company: company.id,
            "icls:invoiceMark": res.mark,
            "icls:invoicesIncomeClassificationDetails": incomeClassificationsDetails,
            reportType: "sales",
        }
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL2 + `/sale/sendClassifications`, requestData, {
                headers: { 'Content-Type': 'application/json' }
            });
            setSendClassificationLoading(false);
            if (response.data.status === "200") {
                if (!fromMass) {
                    toast.success(response.data.message);
                    fetchReport();
                } else {
                    return { status: "200", message: "OK" }
                }
            } else {
                if (!fromMass) {
                    toast.error(response.data.message);
                } else {
                    return { status: "400", message: response.data.message }
                }
            }
        } catch (error) {
            setSendClassificationLoading(false);
            console.log(error);
            if (fromMass) return { status: "400", message: "Σφάλμα κατά την αποστολή."}
        }
    }
    const parentMydataActions = {
        update: (data, id, rowIndex) => {
            let cloneClassifications = classificationsTableData.slice();
            if(cloneClassifications.length >= 0) {
                cloneClassifications = cloneClassifications.map((a) => Object.assign({}, a));
                cloneClassifications[rowIndex] = {...cloneClassifications[rowIndex], ...data};
            }
            setClassificationsTableData(cloneClassifications);
        },
        selected: () => {},
    }

    const classifiedOptions = [
        { label: "Εμφάνιση όλων", value: "" },
        { label: "Μόνο χαρακτηρισμένων", value: "true" },
        { label: "Μόνο μη χαρακτηρισμένων", value: "false" },
        { label: "Μόνο με διαφορά χαρακτηρισμών με το MyData", value: "classificationsDifference"},
    ]

    const showClientsColumns = [
        {
            name: "Πελάτης - Τύπος Παραστατικού",
            field: "name",
            width: "12%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "ΑΦΜ Πελάτη",
            field: "vat",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Πλήθος MyData",
            field: "countMyData",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Καθαρή Αξία MyData",
            field: "myDataNetValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Αξία ΦΠΑ MyData",
            field: "myDataVatValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Συνολική Αξία MyData",
            field: "myDataTotalValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Πλήθος ERP",
            field: "countErp",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Καθαρή Αξία ERP",
            field: "erpNetValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Αξία ΦΠΑ ERP",
            field: "erpVatValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Συνολική Αξία ERP",
            field: "erpTotalValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
    ];

    const columns = [
        {
            name: t('SalesMyData.table.date'),
            field: "date",
            width: "8%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "MARK",
            field: "mark",
            width: "10%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Πελάτης",
            field: "clientName",
            width: "12%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "ΑΦΜ Πελάτη",
            field: "vat",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesMyData.table.invoiceType'),
            field: "myDataType",
            width: "12%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Αριθμός",
            field: "preNumberAndNumber",
            width: "4%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesMyData.table.netValue'),
            field: "totalNetValue",
            width: "6%",
            editable: false,
            inputType: {type: 'currency'}
        },
        {
            name: t('SalesMyData.table.vatAmount'),
            field: "totalVatValue",
            width: "6%",
            editable: false,
            inputType: {type: 'currency'}
        },
        {
            name: t('SalesMyData.table.totalValue'),
            field: "totalAmount",
            width: "6%",
            editable: false,
            inputType: {type: 'currency'}
        },
        {
            name: t('SalesMyData.table.erpStatus'),
            field: "myDataStatus",
            width: "7%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesMyData.table.myDataStatus'),
            field: "myDataSentStatus",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: <div style={{textAlign: "center"}}>Χαρακ</div>,
            field: "classified",
            width: "4%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Ενέργειες",
            field: "changeClassifications",
            width: "7%",
            editable: true,
            hiddenColumn: false,
            inputType: {
                type: "custom-render",
                render: (row, cell) => {
                    const parseIt = row?.myDataJSON ? JSON.parse(row.myDataJSON) : null;
                    return (
                        <div className={"d-flex justify-content-center"}>
                            <Button title={"Εμφάνιση Χαρακτηρισμών"} style={{padding: "7px"}} size={"sm"} className={"mr-1"} onClick={(e) => {
                                e.stopPropagation();
                                e.currentTarget.blur();
                                handleClassificationClicked(row);
                            }}><FaInfoCircle /></Button>
                            {parseIt?.downloadingInvoiceUrl?._text && (
                                <Button title={"Εμφάνιση Παραστατικού"} style={{padding: "7px"}} size={"sm"} className={"mr-1"} onClick={(e) => {
                                    e.stopPropagation();
                                    e.currentTarget.blur();
                                    window.open(parseIt?.downloadingInvoiceUrl?._text, "_blank");
                                }}><FaFileInvoice /></Button>
                            )}
                            {canSeeAI && (
                                <Popover placement={"top"} title={<div style={{textAlign: "center"}}>Κατάσταση AI</div>} content={
                                    <div style={{maxWidth: "220px"}}>{!isEmpty(row?.aiStatus) ? formatAIDocumentStatus(row?.aiStatus, true) : "Δεν έχει αποσταλεί στο Primer AI"}</div>
                                }><Button title={"Κατάσταση AI"} style={{padding: "7px"}} size={"sm"} className={"mr-1"} onClick={(e) => {
                                    e.stopPropagation();
                                    e.currentTarget.blur();
                                    if(!isEmpty(row?.aiStatus)) {
                                        if(row?.aiType === "file") {
                                            dispatch(setAIModuleType("files"));
                                            dispatch(setAIModuleRequestData({...initialAiModuleRequestData, general: row.mark}));
                                        } else if (row?.aiType === "mr") {
                                            dispatch(setAIModuleType("myDataClearance"));
                                            dispatch(setAIMrModuleRequestData({...initialAiMrModuleRequestData, general: row.mark}));
                                        }
                                        dispatch(openTabByType("ai-module", TABS_DATA));
                                    } else if (row.myDataStatus !== "sent") {
                                        setSelectedRows([String(row.mark)]);
                                        setShowMassSendAiModal(true);
                                    } else {
                                        toast.error("Το παραστατικό υπάρχει ήδη στο Primer ERP!");
                                    }
                                }}><RiGeminiFill /></Button></Popover>
                            )}
                        </div>
                    );
                }
            },
        },
    ]

    const classificationsColumns = [
        {
            name: "Αρ. Γραμμής",
            field: "lineNumber",
            width: "5%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Περιγραφή",
            field: "lineName",
            width: "15%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('ProductsNewGeneral.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            disabled: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: invoiceTypes,
            }
        },
        {
            name: t('ProductsNewGeneral.table.category'),
            field: "classificationCategory",
            editable: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: icCategory,
            }
        },
        {
            name: t('ProductsNewGeneral.table.type'),
            field: 'classificationType',
            editable: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: icType,
            }
        },
        {
            name: "Καθαρή Αξία",
            field: "netPrice",
            hiddenColumn: false,
            width: "10%",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
    ];
    const fetchReport = (forceRefresh = false, fromPagination = false) => {
        setLoading(true);
        let cloneReqData = {...requestData};
        cloneReqData.company = company.id;
        if(canSeeAI) cloneReqData.enabledAi = true;
        cloneReqData.year = String(company.year);
        if(!fromPagination) {
            cloneReqData.page = 1;
            setSelectedRows([]);
        }
        dispatch(setSalesMyDataReportRequestData({...cloneReqData, page: 1, totalPages: 0, totalItems: 0}));
        let reqUrl = "/report/fetch-mydata-report";
        if (forceRefresh) {
            cloneReqData.page = 1;
            reqUrl = "/report/mydata-report";
            setShowLoader(true);
        }
        let invTypes = [];
        if (cloneReqData.invoiceType.length > 0) invTypes = cloneReqData.invoiceType.flatMap((o) => o.value);
        let classTypes = [];
        if (cloneReqData.classificationTypes.length > 0) classTypes = cloneReqData.classificationTypes.flatMap((o) => o.value);
        axios.post(process.env.REACT_APP_API_URL2 + reqUrl, {...cloneReqData, invoiceType: invTypes, classificationTypes: classTypes, page: cloneReqData.page}, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            setLoading(false);
            setShowLoader(false);
            if(res.data.status === "200") {
                if (res.data.data?.data) {
                    let resData = [...res.data.data.data];
                    if(resData.length > 0) {
                        resData.forEach((row) => {
                            if(row.date) row.date = moment(row.date).format("DD/MM/YYYY");
                            if(row.preNumber && row.preNumber !== "noprefix") {
                                row.preNumberAndNumber = String(row.preNumber + " " + row.number);
                            } else {
                                row.preNumberAndNumber = row.number;
                            }
                            row.vatAmount = row.totalVatValue;
                        })
                    } else {
                        dispatch(setSalesMyDataReportData([]));
                        dispatch(setSalesMyDataReportClientsData([]));
                        dispatch(setSalesMyDataReportRequestData({...cloneReqData, page: 1, totalPages: 0, totalItems: 0}));
                        toast.info("Δεν βρέθηκε καμία πώληση.");
                    }
                    let newRequestData = {...cloneReqData};
                    if(res.data.data.totalPages) newRequestData = {...newRequestData, totalPages: res.data.data.totalPages, totalItems: res.data.data.totalItems};
                    if(res.data.totals) dispatch(setSalesMyDataReportTotals(res.data.totals));
                    if(res.data.filters) newRequestData = {...newRequestData, ...res.data.filters};
                    if(res.data.lastUpdate) newRequestData = {...newRequestData, lastUpdate: res.data.lastUpdate};
                    dispatch(setSalesMyDataReportRequestData(newRequestData));
                    dispatch(setSalesMyDataReportData(resData));
                    dispatch(setSalesMyDataReportClientsData(res.data?.vatData));
                    if (forceRefresh) toast.success("Τα δεδομένα ανανεώθηκαν.");
                } else {
                    dispatch(setSalesMyDataReportData([]));
                    dispatch(setSalesMyDataReportClientsData([]));
                    dispatch(setSalesMyDataReportRequestData({...cloneReqData, page: 1, totalPages: 0, totalItems: 0}));
                    toast.info("Δεν βρέθηκε καμία πώληση.");
                }
            } else {
                dispatch(setSalesMyDataReportData([]));
                dispatch(setSalesMyDataReportClientsData([]));
                let zeroTotals = {...totals};
                for(let k in zeroTotals) {
                    zeroTotals[k] = 0;
                }
                dispatch(setSalesMyDataReportTotals(zeroTotals));
                toast.error(res.data.message, {autoClose: 7000});
            }
        }).catch((err) => {
            setLoading(false);
            setShowLoader(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
    useEffect(() => {
        if (saleMarkFromCloud) {
            fetchAndOpenUniqueSale(saleMarkFromCloud);
        }
        dispatch(fetchAdvancedTypesSales({company: company.id}));
        dispatch(fetchSalesGeneralSettings({company: company.id}));
    }, [])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(false, true);
        }
    }, [pageChanged])

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [salesReportData, selectedRows])

    const handlePage = (str) => {
        if(str === "first") {
            dispatch(setSalesMyDataReportRequestData({...requestData, page: 1}));
            setPageChanged(true);
        } else if (str === "previous") {
            dispatch(setSalesMyDataReportRequestData({...requestData, page: requestData.page - 1}));
            setPageChanged(true);
        } else if (str === "next") {
            dispatch(setSalesMyDataReportRequestData({...requestData, page: requestData.page + 1}));
            setPageChanged(true);
        } else if (str === "last") {
            dispatch(setSalesMyDataReportRequestData({...requestData, page: requestData.totalPages}));
            setPageChanged(true);
        }
    }

    const handleFilterChange = (e, type, name) => {
        let cloneReqData = {...requestData};
        if (type === "datebox" && !isEmpty(e)) {
            cloneReqData = {...cloneReqData, [name] : moment(e).format("DD/MM/YYYY")};
        } else if(name === "aiStatus") {
            cloneReqData = {...cloneReqData, [name] : e.flatMap((o) => o.value)};
        } else if (type === "msdd") {
            cloneReqData = {...cloneReqData, [name] : e};
        } else if (type === "input") {
            cloneReqData = {...cloneReqData, [name] : e.target.value}
        } else if (type === "dropdown") {
            cloneReqData = {...cloneReqData, [name] : e.value};
        } else if (type === "ac") {
            cloneReqData = {...cloneReqData, [name] : e.row.name};
        } else if (type === "checkbox") {
            cloneReqData = {...cloneReqData, [name] : e.target.checked};
        }
        dispatch(setSalesMyDataReportRequestData(cloneReqData));
    }

    const handleShowExistingAccountingRecord = () => {
        if (classificationsRowData.mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/buy/get-accounting-record-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: classificationsRowData.mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    setShowClassificationsModal(false);
                    setShowNewSaleModal(false);
                    if (res.data.data) {
                        dispatch(openAccountingRecordLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση του λογιστικού άρθρου.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση του ΜΑΡΚ.");
        }
    }

    const handleShowExistingSale = () => {
        if (classificationsRowData.mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/sale/get-sale-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: classificationsRowData.mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    setShowClassificationsModal(false);
                    setShowNewSaleModal(false);
                    if (res.data.data) {
                        dispatch(openSaleLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        }
    }

    const fetchAndOpenUniqueSale = (mark) => {
        axios.get(`${process.env.REACT_APP_API_URL2}/sale/get-sale-by-mark-mydata`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                mark: mark,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const rowData = res.data.data;
                if (rowData.date) rowData.date = moment(rowData.date).format("DD/MM/YYYY");
                if (rowData.preNumber && rowData.preNumber !== "noprefix") {
                    rowData.preNumberAndNumber = String(rowData.preNumber + " " + rowData.number);
                } else {
                    rowData.preNumberAndNumber = rowData.number;
                }
                rowData.vatAmount = rowData.totalVatValue;

                setClassificationsRowData(rowData);
                setTimeout(() => {
                    setShowNewSaleModal(true);
                }, 200)
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const aiStatusOptions = [
        {label: "Καταχωρημένο", value: "complete"},
        {label: "Αναμονή ενέργειας χρήστη", value: "waiting_user"},
        {label: "Επεξεργασία από AI", value: "pending"},
        {label: "Απόρριψη από χρήστη", value: "declined"},
        {label: "Σφάλμα", value: "error"},
        {label: "Μη Απεσταλμένο", value: "notSent"},
    ]

    const sendInvoiceToAi = (mark, myDataJSON) => {
        axios.post(process.env.REACT_APP_API_URL2 + "/ai/mydata-add-to-ai", {company: company.id, mark: mark, myDataJSON, type: "sale"}, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Το παραστατικό εστάλη στο Primer Ai");
                setShowClassificationsModal(false);
                fetchReport();
            } else {
                toast.error(res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <ReportsTemplate templateType={"sales-mydata-report"} requestData={requestData} fetchReport={() => fetchReport()} setRequestData={(data) => dispatch(setSalesMyDataReportRequestData(data))} header={"Αναφορά MyData Πωλήσεων"} />
            {showLoader && (<Loader/>)}
            <div hidden={showLoader} onKeyDown={((e) => {
                    if(e.key === "Enter") fetchReport()
                })}>
                <Row>
                    <Col md={2}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => dispatch(setSalesMyDataReportRequestData({
                                ...requestData,
                                date_from: from,
                                date_to: to
                            }))}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_from"
                            selected={isEmpty(requestData.date_from) ? moment().toDate() : moment(requestData.date_from, "DD/MM/YYYY").toDate()}
                            label={t('SalesMyData.dateFrom')}
                            onChange={(e) => handleFilterChange(e, "datebox", "date_from")}
                            allowOtherYears={false}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_to"
                            selected={isEmpty(requestData.date_to) ? moment().toDate() : moment(requestData.date_to, "DD/MM/YYYY").toDate()}
                            label={t('SalesMyData.dateTo')}
                            onChange={(e) => handleFilterChange(e, "datebox", "date_to")}
                            allowOtherYears={false}
                        />
                    </Col>
                    <Col md={2}>
                        {!isEmpty(requestData.lastUpdate) && (
                            <Badge bg={"primary"} className={"mt-3"}>
                                Τελευταία ανανέωση από το My Data: <br/>
                                {moment(requestData.lastUpdate).format("DD/MM/YYYY HH:mm:ss")}
                            </Badge>
                        )}
                    </Col>
                    <Col md={4}>
                        <Button onClick={() => fetchReport(true)} className={"float-right"} disabled={loading}>
                            Εφαρμογή φίλτρων & αναζήτηση από MyData{" "}
                            {loading && (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)}
                        </Button>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <label className={"text-muted"}><i>Φίλτρα Αναζήτησης</i></label>
                    <Col md={2}>
                        <Dropdown
                            label={t('SalesMyData.invoiceType')}
                            name="invoiceType"
                            defaultValue={requestData.invoiceType}
                            key={Math.random()}
                            multiSelect={true}
                            enabledValue={true}
                            options={invoiceTypes}
                            onChange={(e) => handleFilterChange(e, "msdd", "invoiceType")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            label={"ΑΦΜ Πελάτη"}
                            name={"clientVAT"}
                            value={requestData.clientVAT}
                            onChange={(e) => handleFilterChange(e, "input", "clientVAT")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            label={t('SalesMyData.showFilter')}
                            options={showFilterOptions}
                            defaultValue={requestData["showFilter"]}
                            value={requestData["showFilter"] ? getDefaultOptionByValue(showFilterOptions, requestData["showFilter"], "value", "label", "value") : ""}
                            enabledValue={true}
                            name="showFilter"
                            searchEnable={true}
                            onChange={(e) => handleFilterChange(e, "dropdown", "showFilter")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            label={"Κανάλι myDATA"}
                            options={invoicesFromChannelOptions}
                            defaultValue={requestData["invoicesFromChannel"]}
                            value={requestData["invoicesFromChannel"] ? getDefaultOptionByValue(invoicesFromChannelOptions, requestData["invoicesFromChannel"], "value", "label", "value") : ""}
                            enabledValue={true}
                            name="invoicesFromChannel"
                            searchEnable={true}
                            onChange={(e) => handleFilterChange(e, "dropdown", "invoicesFromChannel")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            options={classifiedOptions}
                            name={"classified"}
                            label={"Εμφάνιση χαρακτηρισμένων"}
                            defaultValue={classifiedOptions.find((el) => el.value === requestData.classified)}
                            key={Math.random()}
                            onChange={(e) => handleFilterChange(e, "dropdown", "classified")}
                        />
                    </Col>
                    <Col md={2}>
                        <BetterCheckBox
                            name={"showAccounting"}
                            className={"mt-4"}
                            text={"Εμφάνιση εγγραφών από Λογιστική"}
                            checked={requestData.showAccounting}
                            onChange={(e) => handleFilterChange(e, "checkbox", "showAccounting")}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <Input
                            type={"number"}
                            label={"Αριθμός Τιμολογίου από"}
                            name={"number_from"}
                            autoComplete={"off"}
                            value={requestData.number_from}
                            onChange={(e) => handleFilterChange(e, "input", "number_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            type={"number"}
                            label={"Αριθμός Τιμολογίου μέχρι"}
                            name={"number_to"}
                            autoComplete={"off"}
                            value={requestData.number_to}
                            onChange={(e) => handleFilterChange(e, "input", "number_to")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            type={"number"}
                            label={"Συνολική αξία από"}
                            name={"totalSum_from"}
                            autoComplete={"off"}
                            value={requestData.totalSum_from}
                            onChange={(e) => handleFilterChange(e, "input", "totalSum_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            type={"number"}
                            label={"Συνολική αξία μέχρι"}
                            name={"totalSum_to"}
                            autoComplete={"off"}
                            value={requestData.totalSum_to}
                            onChange={(e) => handleFilterChange(e, "input", "totalSum_to")}
                        />
                    </Col>
                    <Col md={3}>
                        <BetterCheckBox
                            name={"showClients"}
                            className={"mt-4"}
                            text={"Εμφάνιση αποτελεσμάτων ανά πελάτη"}
                            checked={requestData.showClients}
                            onChange={(e) => handleFilterChange(e, "checkbox", "showClients")}
                        />
                    </Col>
                </Row>
                <Row className={"justify-content-end mt-2"}>
                    <Col md={canSeeAI ? 3 : 5}>
                        <Input
                            name={"marks"}
                            label={"MARKS διαχωρισμένα με κόμμα (,)"}
                            value={requestData.marks}
                            autoComplete={"off"}
                            onChange={(e) => handleFilterChange(e, "input", "marks")}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            label={"Τύποι E3"}
                            name={"classificationTypes"}
                            options={icType}
                            multiSelect={true}
                            defaultValue={requestData.classificationTypes}
                            onChange={(e) => handleFilterChange(e, "msdd", "classificationTypes")}
                        />
                    </Col>
                    {canSeeAI && (
                        <Col md={3}>
                            <Dropdown
                                name={"aiStatus"}
                                label={"Κατάσταση Επεξεργασίας AΙ"}
                                multiSelect={true}
                                options={aiStatusOptions}
                                defaultValue={aiStatusOptions.filter((el) => requestData.aiStatus.includes(el.value))}
                                onChange={(e) => handleFilterChange(e, "msdd", "aiStatus")}
                            />
                        </Col>
                    )}
                    <Col md={3}>
                        <Button onClick={() => fetchReport()} className={"float-right"} style={{marginTop: "20px"}} disabled={loading}>
                            Εφαρμογή φίλτρων{" "}
                            {loading && (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)}
                        </Button>
                    </Col>
                </Row>
                {requestData.totalPages > 0 && salesReportData.length > 0 && (
                    <React.Fragment>
                        <hr />
                        <div className={"d-flex justify-content-end mb-2"}>
                            {canSeeAI && (
                                <Button size={"sm"} className={"mr-1"} onClick={() => setShowMassSendAiModal(true)}>{selectedRows.length > 0 ? "Αποστολή επιλεγμένων στο Primer AI" : "Μαζική αποστολή στο Primer AI"}</Button>
                            )}
                            <Button size={"sm"} className={"mr-1"} onClick={() => setShowMassSendClassModal(true)}>{selectedRows.length > 0 ? "Αποστολή χαρακτηρισμών επιλεγμένων" : "Μαζική αποστολή χαρακτηρισμών"}</Button>
                            <Button size={"sm"} className={"mr-1"} onClick={() => setShowMassFetchClassModal(true)}>{selectedRows.length > 0 ? "Άντληση χαρακτηρισμών επιλεγμένων" : "Μαζική άντληση χαρακτηρισμών"}</Button>
                            <Button size={"sm"} className={"mr-1"} onClick={() => setShowMassFetchModal(true)}>{selectedRows.length > 0 ? "Δημιουργία πωλήσεων επιλεγμένων" : "Μαζική δημιουργία πωλήσεων"}</Button>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === 1} onClick={() => handlePage("first")}>{t('SalesMyData.first')}</Button>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === 1} onClick={() => handlePage("previous")}>{t('SalesMyData.previous')}</Button>
                            <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1" bg="primary">{t('SalesMyData.page')} {requestData.page} / {requestData.totalPages}</Badge>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === requestData.totalPages} onClick={() => handlePage("next")}>{t('SalesMyData.next')}</Button>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === requestData.totalPages} onClick={() => handlePage("last")}>{t('SalesMyData.last')}</Button>
                        </div>
                        {requestData.totalItems !== 0 && (
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    {selectedRows.length > 0 && (
                                        <React.Fragment>
                                            <i>Έχετε επιλέξει {selectedRows.some((el) => el === -1) ? requestData.totalItems - selectedRows.filter((el) => el !== -1).length : selectedRows.length} παραστατικά</i>
                                            <div className={"ai-module-button ai-module-reprocess-style ml-2 pr-2"} title={"Αποεπιλογή"} onClick={() => {
                                                setSelectedRows([]);
                                            }}><MdDeselect size={22} /> Αποεπιλογή όλων</div>
                                        </React.Fragment>
                                    )}
                                </div>
                                <div>
                                    <i>Σύνολο Αποτελεσμάτων: {requestData.totalItems}</i>
                                </div>
                            </div>
                        )}
                        <EditableTable
                            key={"MyData Report" + incrKey}
                            tableName="MyData Report"
                            data={requestData?.showClients ? showClientsData : salesReportData}
                            allowPagination={false}
                            allowToggleColumns={true}
                            allowInsertRow={false}
                            allowSelectionCheckbox={true}
                            enableNewRowCheckbox={true}
                            allowBulkActions={true}
                            allowPrintResults={true}
                            reportExcelPrint={true}
                            company={company}
                            filters={requestData}
                            actionButtons={{ print: false, delete: false, export: false, edit: false }}
                            allowActions={false}
                            columns={requestData?.showClients ? showClientsColumns : columns}
                            filtersConfig={["quick-edit", "delete"]}
                            onRowClick={(e, row) => handleClassificationClicked(row)}
                            fixedLayout={true}
                            selectedRows={selectedRows}
                            setSelectedRows={((rows) => setSelectedRows(rows))}
                            selectedRowKey={"mark"}
                            totalItems={requestData?.totalItems || 0}
                        />
                        <Row className="justify-content-end mt-3">
                            <Col md={4} className="d-flex justify-content-end">
                                <table className="table table-bordered mb-3">
                                    <tbody>
                                    <tr>
                                        <td style={{textAlign: "center"}}>{t('SalesMyData.pageTotals')}</td>
                                        <td style={{textAlign: "center"}}>{t('SalesMyData.TotalsERP')}</td>
                                        <td style={{textAlign: "center"}}>{t('SalesMyData.TotalsMyData')}</td>
                                        <td style={{textAlign: "center"}}>{t('SalesMyData.differences')}</td>
                                    </tr>
                                    <tr>
                                        <td className="fw-bold">{t('SalesMyData.totalsCount')}</td>
                                        <td>{totals.totalCount}</td>
                                        <td>{totals.totalCountMyData}</td>
                                        <td>{Math.abs(totals.totalCount - totals.totalCountMyData)}</td>
                                    </tr>
                                    <tr>
                                        <td className="fw-bold">{t('SalesMyData.totalNetValue')}</td>
                                        <td>{getGreekCurrencyFormat(totals.totalNetValue)}</td>
                                        <td>{getGreekCurrencyFormat(totals.totalNetValueMyData)}</td>
                                        <td>{getGreekCurrencyFormat(Math.abs(totals.totalNetValueMyData - totals.totalNetValue))}</td>
                                    </tr>
                                    <tr>
                                        <td className="fw-bold">{t('SalesMyData.totalVatAmount')}</td>
                                        <td>{getGreekCurrencyFormat(totals.totalVatValue)}</td>
                                        <td>{getGreekCurrencyFormat(totals.totalVatValueMyData)}</td>
                                        <td>{getGreekCurrencyFormat(Math.abs(totals.totalVatValueMyData - totals.totalVatValue))}</td>
                                    </tr>
                                    <tr>
                                        <td className="fw-bold">{t('SalesMyData.totalValue')}</td>
                                        <td>{getGreekCurrencyFormat(totals.totalValue)}</td>
                                        <td>{getGreekCurrencyFormat(totals.totalValueMyData)}</td>
                                        <td>{getGreekCurrencyFormat(Math.abs(totals.totalValueMyData - totals.totalValue))}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row className="justify-content-end">
                            <Col md={4} className={"d-flex justify-content-end"}>
                                {Number(totals.totalValue.toFixed(2) - totals.totalValueMyData.toFixed(2)) === 0 ? (
                                    <p style={{ color: 'green' }}><b>{t('SalesMyData.discordOk')}</b></p>
                                ) : (
                                    <p style={{ color: 'red' }}><b>{t('SalesMyData.discord')}</b></p>
                                )}
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </div>

            <Modal backdrop={"static"} className="themeModalBig" show={showClassificationsModal} onHide={() => setShowClassificationsModal(false)}>
                <Modal.Header>
                    <Modal.Title>{t('SalesMyData.table.classificationsModalTitle')}</Modal.Title>
                </Modal.Header>
                <Modal.Title style={{ fontStyle: 'italic', fontSize: '12px', marginTop: '5px', textAlign:"center" }}>
                    {t('SalesMyData.table.classificationsModalDesc')}
                </Modal.Title>
                <Modal.Body>
                    <EditableTable
                        key={Math.random() + "table"}
                        tableName="MyData Report Classifications"
                        data={classificationsTableData}
                        allowActions={false}
                        onUpdate={parentMydataActions}
                        columns={classificationsColumns}
                        allowBulkActions={true}
                        invoiceType={classificationsRowData?.myDataType}
                        actionButtons={{ print: false, delete: false, export: false, edit: false }}
                    />
                    <ClassificationsDifferencesTable
                        reportType={"sales"}
                        classificationsRowData={classificationsRowData}
                        successfullCallback={() => {
                            setShowClassificationsModal(false);
                            fetchReport();
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={ () => setShowClassificationsModal(false) }>{t('SalesMyData.table.classificationsModalClose')}</Button>
                    {!isEmpty(classificationsRowData.mark) && classificationsRowData.myDataStatus === "sent" && (
                        <>
                            {classificationsRowData?.existsInAccounting === "true" ? (
                                <Button variant={"primary"} onClick={() => handleShowExistingAccountingRecord()}>Εμφάνιση Λογιστικού Άρθρου</Button>
                            ): (
                                <Button variant={"primary"} onClick={() => handleShowExistingSale()}>Εμφάνιση πώλησης</Button>
                            )}
                        </>
                    )}
                    {(classificationsRowData.myDataStatus !== "sent" && isEmpty(classificationsRowData?.aiStatus) && canSeeAI && checkPermission("custom-ai", permissionsData)) && (
                        <Button variant="primary" onClick={() => sendInvoiceToAi(classificationsRowData?.mark, classificationsRowData?.myDataJSON)}>Αποστολή στο Primer Ai</Button>
                    )}
                    {classificationsRowData.myDataStatus !== "sent" && (
                        <Button variant="primary" onClick={() => {
                            setShowClassificationsModal(false);
                            setShowNewSaleModal(true);
                        }}>Δημιουργία Πώλησης</Button>
                    )}
                    <Button variant="primary" onClick={() => sendClassifications(false, {...classificationsRowData, classifications: classificationsTableData})} disabled={sendClassificationLoading}>
                        {t('SalesMyData.table.classificationsModalSave')}
                        {sendClassificationLoading && <Spinner animation="border" variant="dark" />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <NewSaleModal
                show={showNewSaleModal}
                setShow={(bool) => {
                    if (!saleMarkFromCloud) setShowNewSaleModal(bool)
                }}
                classificationsRowData={classificationsRowData}
                refreshFunction={fetchReport}
            />

            <MassSaleModal
                show={showMassFetchModal}
                setShow={setShowMassFetchModal}
                filters={requestData}
                selectedRows={selectedRows}
                successfulCallback={() => fetchReport(false)}
            />

            <MassFetchClassificationsModal
                show={showMassFetchClassModal}
                setShow={setShowMassFetchClassModal}
                reportType={"sales"}
                filters={requestData}
                selectedRows={selectedRows}
                successfullCallback={() => fetchReport(false)}
            />

            <MassSendClassificationsModal
                show={showMassSendClassModal}
                setShow={setShowMassSendClassModal}
                reportType={"sales"}
                filters={requestData}
                selectedRows={selectedRows}
                sendClassifications={sendClassifications}
                successfullCallback={() => fetchReport(false)}
            />
            <SendToAiModal
                show={showMassSendAiModal}
                setShow={setShowMassSendAiModal}
                reportType={"sales"}
                filters={requestData}
                selectedRows={selectedRows}
                successfullCallback={() => fetchReport(false)}
            />
        </React.Fragment>
    )
}

export default SalesMydataReport;
